import {Deserializable} from '../deserializable';
import {Staffs} from '../staff/staffs';

export  class CalendarDepartComment implements Deserializable
{
  public  id: number;
  public  maXLId: number;
  public  maNam: number;
  public  donViId: number;
  public  comment: string;
  public  staffId: number;
  public  created: string;
  public  staffs:  Staffs;
  public status: number;
  public soLanDoc: number;
  public thoiGianXem: string;
  public thoiGianXemLanDau: string;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.staffs = input.staffs!= null ? new Staffs().deserialize(input.staffs): null;
    return this;
  }
}
